import script from "./DamageReportItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DamageReportItem.vue?vue&type=script&lang=ts&setup=true"

import "./DamageReportItem.vue?vue&type=style&index=0&id=f6d86e50&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6d86e50"]])

export default __exports__